import { render, staticRenderFns } from "./TwPermitLinking.vue?vue&type=template&id=58233c70&scoped=true&"
import script from "./TwPermitLinking.vue?vue&type=script&lang=js&"
export * from "./TwPermitLinking.vue?vue&type=script&lang=js&"
import style0 from "./TwPermitLinking.vue?vue&type=style&index=0&id=58233c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58233c70",
  null
  
)

export default component.exports